import React, { useContext, useEffect, useState } from "react";
import FileContext from "../context/Context";
import { Typography, Box, LinearProgress } from "@mui/material";

const ImageProgressBar = () => {
  const [progressPercentage, setProgressPercentage] = useState(0);
  const {setCapturedInspectionImages, capturedInspectionImages } = useContext(FileContext);
  console.log(capturedInspectionImages, "8")
  useEffect(() => {
    const capturedCount = capturedInspectionImages.length;
    setProgressPercentage(capturedCount / 21 * 100);
  }, [capturedInspectionImages]);
  window.addEventListener("popstate", () => {
    console.log("User clicked back button");
    setCapturedInspectionImages([]);
  });
  return (
    <Box
      sx={{
        margin: "auto",
        marginTop: "0.2rem",
        marginBottom: "0.2rem",
        position: "relative",
        width: "13vw",
        height: "10vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        borderRadius: "5px",
        padding: "1rem 0.4rem",
        "@media (max-width: 900px)and (orientation: landscape)": {
          width: "20vw",
        },
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            height: 7,
            // borderRadius: 5,
            backgroundColor: "#f0f0f0",
            "& .MuiLinearProgress-bar": {
              //   borderRadius: 5,
              backgroundColor: "#ff0088"
            }
          }}
        />
      </Box>
      <Typography
        variant="body2"
        sx={{ marginLeft: "10px" }}
      >
        {Math.round(progressPercentage)}%
      </Typography>
    </Box>
  );
};

export default ImageProgressBar;
